function Banner() {
  return (
    <div className="banner">
      <img className="img-fluid" src="/images/slide1.jpg" alt="" />
    </div>
  );
}
export default Banner;
